{
  "recommendationAccepted": true,
  "documentsRequested": false,
  "numberOfDocumentsRequested": 0,
  "setCompletionDateForEmail": "",
  "opportunityOwnerTextForEmail": "Sarah Johnson",
  "ownerEmailAddress": "devmode@mojomortgages.com",
  "flexRoles2": "BTL Specialist Mortgage Expert",
  "amount": 499,
  "stageName": "Quoted",
  "opportunityRecordType1": "BTL Purchase",
  "mipIssuedToCustomer": false
}
